import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Grid, OutlinedInput } from '@material-ui/core';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as statisticsActionMgr from '../action-mgr';
import * as statisticsReducers from '../reducer';
import * as strings from '../../helpers/strings';
import { getFastDataStationId } from '../../helpers/common';

const styles = {
  formControlWrapper: { marginBottom: 15 },
  formControlWrapperSelectMenu: {
    '& > div > div': {
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)' 
    }
  }
};

class StationStatisticsSelect extends React.Component {

  componentDidMount() {
    const { setSelectStatisticsStation, stations } = this.props;

    if (stations.length > 0) {
      const filteredStations = stations.filter(station => station.id === getFastDataStationId());
      
      if (filteredStations.length > 0) {
        setSelectStatisticsStation(filteredStations[0].name);
      } else {
        setSelectStatisticsStation(stations[stations.length - 1].name);
      }
    }
  }

  handleStationChange = (event) => {
    const {
      setSelectStatisticsStation,
      updateBiDirectionalEnergyFilter,
      resetBiDirectionalData,
      resetStatisticsView,
      resetStatisticsDateSelections,
    } = this.props;
  
    const selectedStationName = event.target.value;
  
    // Step 1: Set the selected station (Redux)
    setSelectStatisticsStation(selectedStationName);
  
    // Step 2: Reset filter, data, view, and date selections
    updateBiDirectionalEnergyFilter({
      facilities: [],
      type: 'all',
      time: '',
    });
    resetBiDirectionalData();
    resetStatisticsView();
    resetStatisticsDateSelections();
  
  };
  
  
  render() {
    const { selectedStationName, stations, classes } = this.props;

    return (
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
            <InputLabel htmlFor={strings.idSelectStation}>{strings.lblStation}</InputLabel>
            <Select
              value={selectedStationName}
              onChange={this.handleStationChange}
              input={
                <OutlinedInput
                  labelWidth={60}
                  name={strings.lblStations}
                  id={strings.idSelectStation}
                  key="stationSelect"
                  className={classes.formControlWrapperSelectMenu}
                />
              }
            >
              {(stations.sort((a, b) => (a.name > b.name) ? 1 : -1)).map(station =>
                <MenuItem key={station.id} value={station.name}>
                  {station.name} - {station.description} {/* Displaying the description next to the name */}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  selectedStationName: statisticsReducers.getSelectedStatisticsStationName(state),
  stations: userStationsReducers.getStations(state),
  biDirectionalEnergyFilter: statisticsReducers.getBiDirectionalEnergyFilter(state),
});

const mapActionsToProps = {
  setSelectStatisticsStation: statisticsActionMgr.setSelectStatisticsStation,
  callBiDirectionalMeter: statisticsActionMgr.callBiDirectionalMeter,
  updateBiDirectionalMeterList: statisticsActionMgr.updateBiDirectionalMeterList,
  updateBiDirectionalEnergyFilter: statisticsActionMgr.updateBiDirectionalEnergyFilter,
  resetBiDirectionalData: statisticsActionMgr.resetBiDirectionalData, 
  resetStatisticsView: statisticsActionMgr.resetStatisticsView,
  resetStatisticsDateSelections: statisticsActionMgr.resetStatisticsDateSelections,
  updateBiDirectionalDates: statisticsActionMgr.updateBiDirectionalDates,
  callBiDirectionalEnergyDataDates: statisticsActionMgr.callBiDirectionalEnergyDataDates,

};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(StationStatisticsSelect)
);
